<template>
  <alert-banner v-if="warningMsg" class="cert-expiry-banner" icon="i-lucide-triangle-alert" :message="warningMsg" />
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { CertificateService } from 'app-core';
import AlertBanner from './AlertBanner.vue';

const warningMsg = ref<string | undefined>(undefined)

onMounted(async () => {
  const certInfo = await CertificateService.getInfo()
  warningMsg.value = certInfo.warningMsg
})
</script>
